import React, { FC } from 'react'
import styles from 'styles/components/modal.module.scss'
import { ConfirmModal } from 'components/Modal'
import { BasicCard } from 'components/Card'
import { CloseButton } from 'components/Button'
import { useDispatch, useSelector } from 'react-redux'
import { State } from 'index'
import {
  getModalContent,
  getModalDescription,
  getModalEdited,
  getModalOpen,
  getModalTitle,
} from 'reducks/modal/selectors'
import { useFixedBackface } from 'hooks/effect'
import { useCloseModal } from 'hooks/modal'

const Modal: FC = () => {
  const dispatch = useDispatch()

  const edited = useSelector((state: State) => getModalEdited(state))
  const content = useSelector((state: State) => getModalContent(state))
  const description = useSelector((state: State) => getModalDescription(state))
  const open = useSelector((state: State) => getModalOpen(state))
  const title = useSelector((state: State) => getModalTitle(state))

  const closeModalCallback = useCloseModal(dispatch, edited)

  // モーダルOPEN時に背景を固定する（スクロールを禁止する）
  useFixedBackface(open, [open])

  return (
    // styles.openクラスを適用するとopacityのアニメーションでフェードイン
    <div className={open ? styles.open : ''}>
      <div className={styles.overlay}>
        <div className={styles.overlay__background} onClick={closeModalCallback} />
        {open && (
          <div className={styles.overlay__container}>
            <BasicCard
              buttonComponent={<CloseButton onClick={closeModalCallback} />}
              dataCy={'basic-card-basic-modal'}
              description={description}
              title={title}
            >
              {content}
            </BasicCard>
          </div>
        )}
        <ConfirmModal />
      </div>
    </div>
  )
}

export default Modal
